module.exports = __webpack_public_path__ + "img/violet_132.acdc3738.png";